import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { Colors } from 'bz-core-controls/styles/colours';
import GUID from 'bz-utilities/modules/variables/guid';
import moment from 'moment';
import featureFlag from 'tm3-core/stores/feature-store';

interface IProps {
  prontoCache?: any;
  charge: any;
}

@inject('prontoCache')
@observer
class ChargeExtras extends React.Component<IProps> {
  render() {
    if (!this.show) return null;

    let style = {
      color: Colors.blue500,
      borderColor: Colors.blue500
    };

    return (
      <React.Fragment>
        <div className="flex-none" style={{ fontSize: '120%', fontWeight: 'bold' }}>
          {this.appointmentDate}
          {this.service}
          <span className="statusLabel" style={style}>
            PRONTO
          </span>
        </div>
      </React.Fragment>
    );
  }

  @computed
  get show() {
    const { prontoServiceId } = this.props.charge;
    return featureFlag.prontoIntegrationEnabled && !!GUID.hasValue(prontoServiceId);
  }

  @computed
  get service() {
    const { prontoCache, charge } = this.props;
    const { prontoServiceId } = charge;

    const services = prontoCache.prontoNetworkServices;

    if (!services) {
      return 'Unknown Service';
    }
    const prontoServiceName = services.getServiceName(prontoServiceId);

    return ` - [${prontoServiceName}]`;
  }

  @computed
  get appointmentDate() {
    const { charge } = this.props;
    const { date } = charge;

    const apptStartDateTime = moment(date).format('DD/MM/YYYY');

    return apptStartDateTime;
  }
}

export default ChargeExtras;
